import React, { useState } from 'react';
import { Box, Typography, Radio, RadioGroup, Paper } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PrimaryButton from './styled/PrimaryButton';
// Import your icons here

const paymentMethods = [
  { 
    label: 'Stripe', 
    value: 'stripe', 
    icon: (
      <Box sx={{ 
        width: 40, 
        height: 40, 
        borderRadius: '50%', 
        backgroundColor: '#635BFF', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
      }}>
        <Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: '18px' }}>S</Typography>
      </Box>
    )
  },
];

const SelectPaymentMethod = () => {
  const [selected, setSelected] = useState('stripe');
  const navigate = useNavigate();
  const { loanId } = useParams();

  const handleContinue = () => {
    if (!selected) {
      return;
    }

    // Get payment details from URL parameters
    const params = new URLSearchParams(window.location.search);
    const amount = params.get('amount');
    const date = params.get('date');
    
    // Navigate to the payment flow for Stripe with payment details
    const paymentParams = new URLSearchParams();
    paymentParams.append('method', 'stripe');
    if (amount) {
      paymentParams.append('amount', amount);
    }
    if (date) {
      paymentParams.append('date', date);
    }
    
    const queryString = paymentParams.toString();
    navigate(`/loans/${loanId}/payment-flow?${queryString}`);
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 6 }}>
      <Typography variant="h6" sx={{ mb: 4, fontFamily: "'Libre Franklin', sans-serif", color: '#FFFFFF' }}>Select the payment method</Typography>
      <RadioGroup value={selected} onChange={e => setSelected(e.target.value)}>
        {paymentMethods.map(method => (
          <Paper key={method.value} sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 2, borderRadius: 2 }}>
            <Box sx={{ mr: 2 }}>{method.icon}</Box>
            <Typography sx={{ flex: 1 }}>{method.label}</Typography>
            <Radio value={method.value} />
          </Paper>
        ))}
      </RadioGroup>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 6 }}>
        <PrimaryButton variant="outlined" sx={{ minWidth: 120 }} onClick={() => navigate(-1)}>Back</PrimaryButton>
        <PrimaryButton variant="contained" onClick={handleContinue} disabled={!selected}>Continue</PrimaryButton>
      </Box>
    </Box>
  );
};

export default SelectPaymentMethod;
